import { PAGE_NAMES } from '~/shared/constants';

import { P } from './permissions';

export const ROUTE_PERMISSIONS = {
  [PAGE_NAMES.USER_PROFILE]: P.WEB_PROFILE_VIEW,
  [PAGE_NAMES.USER_DIALOGS]: P.WEB_DIALOGS_VIEW,

  [PAGE_NAMES.PLATFORM_USER_PROFILE]: P.PLATFORM_PROFILE_VIEW,
  [PAGE_NAMES.PLATFORM_USER_DIALOGS]: P.PLATFORM_DIALOGS_VIEW,
  [PAGE_NAMES.PLATFORM_COURSES]: P.PLATFORM_COURSES_VIEW,
  [PAGE_NAMES.PLATFORM_VIDEO_COURSES]: P.PLATFORM_VIDEO_COURSES_VIEW,
  [PAGE_NAMES.PLATFORM_STUDENTS_BOARD]: P.PLATFORM_STUDENTS_BOARD_VIEW,
  [PAGE_NAMES.PLATFORM_STUDENTS_LIST]: P.PLATFORM_STUDENTS_LIST_VIEW,

  [PAGE_NAMES.ADMIN_USER_PROFILE]: P.ADMIN_PROFILE_VIEW,
  [PAGE_NAMES.ADMIN_USER_DIALOGS]: P.ADMIN_DIALOGS_VIEW,
} as const;
